import { useRef } from 'react';
import './WhyUs.css';
import Icon from './Icon';
import useReveal from './useReveal';

// Reasons to partner — arranged as an interactive card constellation around a
// central brand graphic. Cards sit gently rotated and straighten on hover.
const CARDS = [
  { text: '17+ years of corporate & industry experience',                       icon: 'award-ribbon', area: 'c0', rot: '-3.5deg' },
  { text: 'Practical learning drawn from experience: Cabin Crew to VP journey',       icon: 'bar-growth',   area: 'c1', rot: '2.5deg'  },
  { text: 'Customised solutions aligned to business goals',                      icon: 'briefcase',    area: 'c2', rot: '-2deg'   },
  { text: 'Programmes relevant to your industry & focused on outcomes',                      icon: 'experiential', area: 'c3', rot: '3.5deg'  },
  { text: 'Certified POSH & POCSO trainer & consultant',                         icon: 'case-study',   area: 'c4', rot: '-2.5deg' },
  { text: 'Trusted partner for communication, leadership & workplace development', icon: 'group',      area: 'c5', rot: '2deg'    },
];

function Centerpiece() {
  const ref = useRef(null);

  // Replay the trend-line draw on every hover by restarting its animation.
  const redraw = () => {
    const el = ref.current;
    if (!el) return;
    el.style.animation = 'none';
    void el.getBoundingClientRect(); // force reflow so the animation restarts
    el.style.animation = '';
  };

  return (
    <div className="whyus__center" aria-hidden="true" onMouseEnter={redraw}>
      <svg viewBox="0 0 300 340" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="wu-dark" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#211D19" />
            <stop offset="1" stopColor="#171412" />
          </linearGradient>
          <linearGradient id="wu-gold" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0" stopColor="#F2C94C" />
            <stop offset="1" stopColor="#CE9D03" />
          </linearGradient>
        </defs>

        <rect x="2" y="2" width="296" height="336" rx="16" fill="url(#wu-dark)" stroke="rgba(206,157,3,0.30)" strokeWidth="1.5" />
        <rect x="14" y="14" width="272" height="312" rx="9" fill="none" stroke="rgba(206,157,3,0.18)" strokeWidth="1" />

        {/* Faint monogram */}
        <text x="150" y="212" textAnchor="middle" className="whyus__mono">W</text>

        {/* Concentric rings */}
        <circle cx="150" cy="150" r="86" fill="none" stroke="rgba(206,157,3,0.18)" strokeWidth="1" />
        <circle cx="150" cy="150" r="62" fill="none" stroke="rgba(206,157,3,0.28)" strokeWidth="1" />

        {/* Upward growth arrow */}
        <path ref={ref} className="wu-arrow" d="M 96 196 L 132 158 L 158 178 L 208 118"
          stroke="url(#wu-gold)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M 190 116 L 210 116 L 210 136"
          stroke="url(#wu-gold)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />

        {/* Accent dots */}
        <circle cx="96"  cy="196" r="4.5" fill="#CE9D03" />
        <circle cx="132" cy="158" r="4.5" fill="#CE9D03" />
        <circle cx="158" cy="178" r="4.5" fill="#CE9D03" />
      </svg>
    </div>
  );
}

export default function WhyUs() {
  const ref = useReveal({ stagger: 90, maxStaggered: 6 });

  return (
    <section id="why-us" className="whyus">
      <div className="container">
        <h2 className="whyus__title">Why partner with WAYFWD</h2>

        <div className="whyus__constellation" ref={ref}>
          {CARDS.slice(0, 3).map((card) => (
            <div className="whyus__card" style={{ gridArea: card.area }} key={card.area}>
              <div className="whyus__card-inner" style={{ '--rot': card.rot }}>
                <span className="whyus__card-icon" aria-hidden="true">
                  <Icon name={card.icon} size={22} strokeWidth={1.7} />
                </span>
                <span className="whyus__card-text">{card.text}</span>
              </div>
            </div>
          ))}

          <Centerpiece />

          {CARDS.slice(3).map((card) => (
            <div className="whyus__card" style={{ gridArea: card.area }} key={card.area}>
              <div className="whyus__card-inner" style={{ '--rot': card.rot }}>
                <span className="whyus__card-icon" aria-hidden="true">
                  <Icon name={card.icon} size={22} strokeWidth={1.7} />
                </span>
                <span className="whyus__card-text">{card.text}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
